export enum RoleEnum {
  SEARCH_ANALYST = 'SEARCH_ANALYST',
  SEARCH_MANAGER = 'SEARCH_MANAGER',
  SEARCH_ADMIN = 'SEARCH_ADMIN',
  EB_ADMIN = 'EB_ADMIN',
  EB_APP = 'EB_APP',
  EB_SERVICES = 'EB_SERVICES',
  PARTNER_REQUESTS = 'PARTNER_REQUESTS',
}
